import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export function RoutePerfDetector() {
    const location = useLocation();
    const startRef = useRef<number>(0);
    const prevPathRef = useRef<string>('');

    useEffect(() => {
        // Mark navigation start time
        const navigationStart = performance.now();
        startRef.current = navigationStart;

        console.log(`[RoutePerf] Navigation started: ${prevPathRef.current} → ${location.pathname}`);

        // Use requestAnimationFrame to measure when content is painted
        const rafId = requestAnimationFrame(() => {
            const paintTime = performance.now() - navigationStart;
            console.log(`[RoutePerf] First paint took ${paintTime.toFixed(0)}ms for ${location.pathname}`);
        });

        return () => {
            // Measure total time when old route unmounts
            const totalDuration = performance.now() - startRef.current;

            if (totalDuration > 100) {
                console.warn(`[RoutePerf] ⚠️ Slow route transition (${totalDuration.toFixed(0)}ms) to: ${location.pathname}`);
            } else if (totalDuration > 50) {
                console.log(`[RoutePerf] ⚡ Route transition (${totalDuration.toFixed(0)}ms) to: ${location.pathname}`);
            } else {
                console.log(`[RoutePerf] ✅ Fast route transition (${totalDuration.toFixed(0)}ms) to: ${location.pathname}`);
            }

            prevPathRef.current = location.pathname;
            cancelAnimationFrame(rafId);
        };
    }, [location.pathname]);

    return null;
}
